<template>
  <v-btn
    color="primary"
    class="mt-2"
    small
    block
    text
    @click="handleClick"
  >
    <v-icon class="mr-1">
      mdi-account-details-outline
    </v-icon> Details
  </v-btn>
</template>

<script>
export default {
  props: {
    params: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    handleClick() {
      // AG Grid will call onCellClicked from the column definition
      // This is handled by the parent component
    },
  },
};
</script>
